export default "__VITE_ASSET__CwEEn2kD__"